import { useMutation } from '@tanstack/react-query';
import * as Api from '../api';

export const useResendEmailVerification = () =>
  useMutation({
    mutationFn: async () => {
      const { data } = await Api.ResendEmailVerification();
      return data;
    },
  });
